// assets/ios-scroll-restore.js
(() => {
  const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (!isiOS) return;

  const isCollection = () => /^\/collections\//.test(location.pathname);
  const storageKey = () => 'cc:colpos:' + location.pathname + location.search;

  const safeJSON = {
    get(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } },
    set(key, val) { try { sessionStorage.setItem(key, JSON.stringify(val)); } catch {} },
    del(key) { try { sessionStorage.removeItem(key); } catch {} },
  };

  // Save scroll + the product handle we clicked from this collection
  function trackProductClicks() {
    if (!isCollection()) return;
    const selector = 'a[href*="/products/"]';
    document.addEventListener('click', (e) => {
      const a = e.target.closest(selector);
      if (!a) return;
      const m = a.href.match(/\/products\/([^/?#]+)/);
      const handle = m ? decodeURIComponent(m[1]) : null;
      safeJSON.set(storageKey(), { y: scrollY || 0, x: scrollX || 0, handle, t: Date.now() });
      // Ensure full navigation (avoid any PJAX-style transition)
      // Canyon normally does full loads, but this guards edge cases:
      // setTimeout(() => { location.href = a.href; }, 0); // uncomment only if you use a transition plugin
    }, { capture: true });
  }

  function restoreByY(pos) {
    if (!pos) return false;
    const root = document.documentElement;
    const prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    const tries = [0, 50, 150, 300, 600, 1200, 2000, 3000];
    tries.forEach(ms => setTimeout(() => scrollTo(pos.x || 0, pos.y || 0), ms));
    setTimeout(() => { root.style.scrollBehavior = prev; }, tries[tries.length - 1] + 60);
    return true;
  }

  function waitForSelector(sel, timeout = 3500) {
    return new Promise((resolve) => {
      const found = document.querySelector(sel);
      if (found) return resolve(found);
      const obs = new MutationObserver(() => {
        const el = document.querySelector(sel);
        if (el) {
          obs.disconnect();
          resolve(el);
        }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => { obs.disconnect(); resolve(null); }, timeout);
    });
  }

  async function restoreByHandle(handle) {
    if (!handle) return false;
    // Try to find a card that links back to that product
    const sel = `a[href*="/products/${CSS.escape(handle)}"]`;
    const link = await waitForSelector(sel, 4000);
    if (!link) return false;

    const root = document.documentElement;
    const prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';

    // Scroll the card into view and nudge a bit so it lands where eyes expect
    link.scrollIntoView({ block: 'center', inline: 'nearest' });
    // Tiny nudge after images load
    [60, 150, 350, 800, 1500].forEach(ms => setTimeout(() => link.scrollIntoView({ block: 'center' }), ms));

    setTimeout(() => { root.style.scrollBehavior = prev; }, 1600);
    return true;
  }

  // Don’t let theme “scroll-to-top” run after a back/forward visit
  function guardAgainstScrollToTop() {
    try { history.scrollRestoration = 'manual'; } catch {}
    const nav = performance.getEntriesByType('navigation')[0];
    const isBF = nav && nav.type === 'back_forward';
    if (isBF) {
      // If Canyon has any global scroll-to-top code, this guard helps:
      // window.__cc_isBackForward = true; // optional flag for your theme.js
    }
  }

  // Save scroll when leaving (iOS puts page into bfcache)
  addEventListener('pagehide', () => {
    if (!isCollection()) return;
    const prev = safeJSON.get(storageKey()) || {};
    safeJSON.set(storageKey(), { ...prev, y: scrollY || 0, x: scrollX || 0, t: Date.now() });
  }, { passive: true });

  addEventListener('pageshow', (e) => {
    guardAgainstScrollToTop();
    // Only restore on collection pages
    if (!isCollection()) return;

    const nav = performance.getEntriesByType('navigation')[0];
    const fromBF = e.persisted || (nav && nav.type === 'back_forward');
    if (!fromBF) return;

    const pos = safeJSON.get(storageKey());
    // Try Y-position immediately, then fall back to handle if layout shifts
    requestAnimationFrame(async () => {
      if (pos) restoreByY(pos);
      if (pos?.handle) {
        // If Y-restore didn’t land correctly due to reflow, ensure we find the card
        await restoreByHandle(pos.handle);
      }
    });
  });

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    try { history.scrollRestoration = 'manual'; } catch {}
    trackProductClicks();
  });
})();
